const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Sodexo24 = function Sodexo24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "m13.338 10.691-.288 1.441c-.127.585-.48.975-1.198.975-.826 0-1.043-.512-.862-1.232.256-1.022 1.09-1.326 2.348-1.184Zm1.3-2.06-.877.055-.278 1.412c-.335-.012-.44-.023-.835-.023-1.235 0-2.313.52-2.598 1.737-.256 1.098.368 1.95 1.727 1.95 1.393 0 2-.727 2.217-1.75l.644-3.381ZM5.12 10.753c-1.286-.117-2.393-.01-2.411.426-.028.656 2.12.084 2.079 1.29-.06 1.773-3.048 1.365-3.787 1.14l.134-.526c1.275.202 2.62.219 2.649-.484.031-.747-2.126-.076-2.075-1.286.037-.9 1.386-1.387 3.593-1.063l-.182.503Zm3.47 1.206c-.186.74-.773 1.204-1.472 1.204-.73 0-1.06-.423-.863-1.204.185-.74.779-1.237 1.478-1.237.698 0 1.042.497.856 1.237Zm-.745-1.843c-1.28 0-2.308.74-2.56 1.843-.254 1.103.435 1.843 1.714 1.843s2.307-.74 2.56-1.843c.254-1.103-.435-1.843-1.714-1.843Zm14.783 3.667h-1.112c-.674-.634-1.965-2.091-2.915-3.633h.817c.902 1.245 3.21 3.633 3.21 3.633Zm1.166-7.216.512-1.067.146 1.085 1.043-.366-.73.935.792.613-1.056.082-.058 1.128-.587-.834-.862.795.323-1.12L22.3 7.68l.99-.564-.407-.966.91.417Zm2.169 5.403c-.19.752-.785 1.223-1.495 1.223-.742 0-1.076-.43-.877-1.223.189-.752.792-1.256 1.501-1.256.71 0 1.06.504.87 1.256Zm-.756-1.872c-1.3 0-2.344.752-2.602 1.872-.257 1.12.443 1.872 1.742 1.872 1.3 0 2.344-.752 2.601-1.872.258-1.12-.442-1.872-1.741-1.872",
      fill: "#2B3797",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M17.758 13.473c2.1-1.166 3.925-2.96 5.22-4.51-.931 2.913-3.17 4.48-5.22 4.51Z",
      fill: "#ED1C24",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M16.926 10.656c.402 0 .621.146.621.425 0 .741-1.444.692-2.08.562.223-.554.73-.987 1.459-.987Zm1.486.385c0-.537-.428-.932-1.399-.932-1.575 0-2.598 1.023-2.598 2.288 0 .818.678 1.497 1.918 1.497.854 0 1.424-.42 1.424-.42-1.087.116-2.422 0-2.422-1.163 0-.047.003-.093.007-.139 1.483.308 3.07-.065 3.07-1.131",
      fill: "#2B3797",
    })
  );
};
Sodexo24.defaultProps = {
  width: "28",
  height: "24",
  viewBox: "0 0 28 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
var Sodexo32 = function Sodexo32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("rect", {
      x: ".5",
      y: ".5",
      width: "31",
      height: "23",
      rx: "3.5",
      fill: "#fff",
      stroke: "#CCC",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "m15.338 10.691-.288 1.441c-.127.585-.48.975-1.198.975-.826 0-1.043-.512-.862-1.232.256-1.022 1.09-1.326 2.348-1.184Zm1.3-2.06-.878.055-.277 1.412c-.335-.012-.44-.023-.835-.023-1.235 0-2.313.52-2.598 1.737-.256 1.098.368 1.95 1.727 1.95 1.393 0 2-.727 2.217-1.75l.644-3.381ZM7.12 10.753c-1.286-.117-2.393-.01-2.411.426-.028.656 2.12.084 2.079 1.29-.06 1.773-3.048 1.365-3.787 1.14l.134-.526c1.275.202 2.62.219 2.649-.484.031-.747-2.126-.076-2.075-1.286.037-.9 1.386-1.387 3.593-1.063l-.182.503Zm3.47 1.206c-.186.74-.773 1.204-1.472 1.204-.73 0-1.06-.423-.863-1.204.185-.74.779-1.237 1.478-1.237.698 0 1.042.497.856 1.237Zm-.745-1.843c-1.28 0-2.308.74-2.56 1.843-.254 1.103.435 1.843 1.714 1.843s2.307-.74 2.56-1.843c.254-1.103-.435-1.843-1.714-1.843Zm14.783 3.667h-1.112c-.674-.634-1.965-2.091-2.915-3.633h.817c.902 1.245 3.21 3.633 3.21 3.633Zm1.166-7.216.512-1.067.146 1.085 1.043-.366-.73.935.792.613-1.056.082-.058 1.128-.587-.834-.862.795.323-1.12L24.3 7.68l.99-.564-.407-.966.91.417Zm2.169 5.403c-.19.752-.785 1.223-1.495 1.223-.742 0-1.076-.43-.877-1.223.189-.752.792-1.256 1.501-1.256.71 0 1.06.504.87 1.256Zm-.756-1.872c-1.3 0-2.344.752-2.602 1.872-.257 1.12.443 1.872 1.742 1.872 1.3 0 2.344-.752 2.601-1.872.258-1.12-.442-1.872-1.741-1.872",
      fill: "#2B3797",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M19.758 13.473c2.1-1.167 3.925-2.96 5.22-4.51-.931 2.913-3.17 4.48-5.22 4.51Z",
      fill: "#ED1C24",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M18.925 10.656c.403 0 .622.146.622.425 0 .741-1.444.692-2.08.563.224-.555.73-.988 1.459-.988Zm1.487.385c0-.537-.428-.932-1.399-.932-1.575 0-2.598 1.023-2.598 2.289 0 .817.678 1.496 1.918 1.496.854 0 1.424-.42 1.424-.42-1.087.116-2.422 0-2.422-1.163 0-.046.003-.093.007-.139 1.483.308 3.07-.064 3.07-1.131",
      fill: "#2B3797",
    })
  );
};
Sodexo32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Sodexo24,
  32: Sodexo32,
};
export function Sodexo(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Sodexo' icon. Please use one of the available sizes: '24', '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
